import { Status } from "../DataFrame";
import { IDIService } from "../IDIService";

/// <summary>
/// Service for storing app data on controller. This can be used to store custom configuration or data for given user or for all users.
/// Data is stored in JSON format as string on controller. Repository this allows to store data in context of logged in user or data that is shared between all users.
/// To switch between user and global storage, use isGlobalForAllUsers parameter.
/// </summary>
export interface IRemoteStorageService extends IDIService {
	/// <summary>
	/// Saves data to remote storage. If isGlobalForAllUsers is true, data will be available for all users on controller. If false, data will be available only for current user.
	/// </summary>
	SaveAsync(resourceGuid: string, isGlobalForAllUsers: boolean, data: any): Promise<Status>;
	/// <summary>
	/// Reads data from remote storage. If isGlobalForAllUsers is true, data will be retrieved set for all users on controller. If false, data will be retrieved that is set only for current user.
	ReadAsync<T>(resourceGuid: string, isGlobalForAllUsers: boolean, skipLocalChache: boolean): Promise<RemoteStorageDataEntry<T> | Status>;
	/// <summary>
	/// Removes data from remote storage. If isGlobalForAllUsers is true, data will be removed for all users on controller. If false, data will be removed only for current user.
	/// </summary>
	RemoveAsync(resourceGuid: string, isGlobalForAllUsers: boolean): Promise<Status>;
}

export class RemoteStorageDataEntry<T> {
	ResourceGuid: string = "";
	Data: T = null as any;
	IsGlobal: boolean = false;
	InsertTime: Date = new Date();
}